import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import useReceiptCustomization from "./useReceiptCustomization";
import styles from "../PrinterConfigForm/styles.module.scss";
import primaryComponents from "../../../primaryComponents";
import ReceiptIcon from "../../../../assets/svgIcons/ReceiptIcon";
import useValidation from "./useValidation";
import EnlumiIcon from "../../../../assets/svgIcons/EnlumiIcon";

const ReceiptCustomization = () => {
  const { details, setDetails, onSubmitData, businessProfile, isLoading } =
    useReceiptCustomization();
  const { handleSubmit, register, control } = useValidation(details);
  return (
    <div
      className={`${globalStyles.cardWithBackground} ${styles.printerConfig} white p-4`}
      style={{ gap: "15px" }}
    >
      <div
        className={`${styles.printerConfig__header} ${globalStyles.pageHeaders}`}
      >
        <div style={{ maxWidth: "600px" }}>
          <p>Customize your receipt’s content</p>
        </div>
        <div style={{ cursor: "pointer" }}>
          <ReceiptIcon className="ml-auto" />
        </div>
      </div>

      <div
        className="d-flex flex-wrap justify-content-between"
        style={{ gap: "6px" }}
      >
        <form
          style={{ width: "100%", maxWidth: "700px" }}
          onSubmit={handleSubmit(onSubmitData)}
        >
          <div className="mb-4">
            <h6>Footer 1</h6>
            <primaryComponents.InputFieldV2
              control={control}
              label="Add your title here"
              placeholder="Title"
              name="title"
              className="white"
              value={details?.title}
              onChange={({ target: { value } }) => {
                setDetails((prev) => ({ ...prev, title: value }));
              }}
              register={register}
            />
          </div>
          <div className="mt-2">
            <h6>Footer 2</h6>
            <primaryComponents.TextAreaV2
              control={control}
              label="Add your description here"
              placeholder="description"
              name="description"
              className="white"
              value={details?.description}
              onChange={({ target: { value } }) => {
                setDetails((prev) => ({ ...prev, description: value }));
              }}
              register={register}
            />
          </div>
          <div className={`mt-2 ${styles.hideOnMobile}`}>
            <primaryComponents.Button
              type="submit"
              isLoading={isLoading}
              disabled={isLoading}
              loadingText={"Submitting..."}
              classNames="btn btn--primary smallBtn ml-auto"
            >
              Submit
            </primaryComponents.Button>
          </div>
        </form>
        <div
          className={`${styles.receiptContainer} ${globalStyles.cardWithBorder}`}
          style={{ width: "100%", maxWidth: "400px" }}
        >
          <div className={`${styles.receiptHeader}`}>Sales Receipt</div>
          <div
            className={`${styles.receiptBox}`}
            style={{ width: "100%", maxWidth: "500px" }}
          >
            <div style={{ textAlign: "left", marginBottom: "10px" }}>
              <EnlumiIcon />
            </div>

            {/* Business Info */}
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "13px",
              }}
            >
              <h2 className={`${styles.storeName}`}>
                {businessProfile?.business_name}
              </h2>
              <h2 className={`${styles.subHeader}`}>
                {businessProfile?.address}
              </h2>
            </div>

            <div className="mb-4">
              {[
                ["Order Entry Date", "May 19, 2025 04:34 PM"],
                ["Order Number", "425618747986"],
                ["Payment Mode", "Cash"],
                ["Customer Name", "N/A"],
                ["Cashier Name", "AZ Develop Abdulazeez"],
              ].map(([label, value], idx) => (
                <div key={idx} className={`${styles.row}`}>
                  <span>
                    <strong>{label}</strong>
                  </span>
                  <span>{value}</span>
                </div>
              ))}
            </div>

            {/* Ordered Items Title */}
            <h3 className={`${styles.subHeader} mt-2`}>Ordered Items</h3>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "30px",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
              }}
            >
              <thead>
                <tr style={{ borderBottom: "1px solid black" }}>
                  <th
                    style={{ textAlign: "left", padding: "8px", width: "40%" }}
                  >
                    Item
                  </th>
                  <th
                    style={{ textAlign: "right", padding: "8px", width: "10%" }}
                  >
                    Qty
                  </th>
                  <th
                    style={{ textAlign: "right", padding: "8px", width: "25%" }}
                  >
                    Price
                  </th>
                  <th
                    style={{ textAlign: "right", padding: "8px", width: "25%" }}
                  >
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: "1px solid black" }}>
                  <td style={{ padding: "8px", textAlign: "left" }}>Rice</td>
                  <td style={{ padding: "8px", textAlign: "right" }}>1</td>
                  <td style={{ padding: "8px", textAlign: "right" }}>
                    3,000.00
                  </td>
                  <td style={{ padding: "8px", textAlign: "right" }}>
                    3,000.00
                  </td>
                </tr>
                <tr style={{ borderBottom: "1px solid black" }}>
                  <td style={{ padding: "8px", textAlign: "left" }}>Fish</td>
                  <td style={{ padding: "8px", textAlign: "right" }}>1</td>
                  <td style={{ padding: "8px", textAlign: "right" }}>
                    4,000.00
                  </td>
                  <td style={{ padding: "8px", textAlign: "right" }}>
                    7,000.00
                  </td>
                </tr>
              </tbody>
            </table>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "5px",
              }}
            >
              <strong>Sub Total</strong>
              <span>NGN7,000.00</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "5px",
              }}
            >
              <strong>VAT</strong>
              <span>NGN150.00</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "5px",
              }}
            >
              <strong>Service Charge (10.00%)</strong>
              <span>NGN300.00</span>
            </div>
            <hr />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
              <span>Total</span>
              <span>NGN3,450.00</span>
            </div>
            <hr />
            <div className={`${styles.footerOne}`}>Footer 1</div>
            <div className={`${styles.settled}`}>{details?.title}</div>
            <div className={`${styles.footerTwo}`}>Footer 2</div>

            <p className={`${styles.footerText}`}>{details?.description}</p>
          </div>
        </div>
      </div>
      <div className={`mt-2 ${styles.hideOnDesktop}`}>
        <primaryComponents.Button
          onClick={handleSubmit(onSubmitData)}
          isLoading={isLoading}
          disabled={isLoading}
          loadingText={"Submitting..."}
          classNames="btn btn--primary smallBtn ml-auto"
        >
          Submit
        </primaryComponents.Button>
      </div>
    </div>
  );
};

export default ReceiptCustomization;
